// extracted by mini-css-extract-plugin
module.exports = {"level_0":"SuggestionCard_level_0__3t8AC","level_1":"SuggestionCard_level_1__3p6n2","level_3":"SuggestionCard_level_3__376E-","level_2":"SuggestionCard_level_2__3CMUV"};